// extracted by mini-css-extract-plugin
export default {"selectWide":"index_selectWide__rrXql","wrapper":"index_wrapper__joPbH","label":"index_label__DS5+n","label-text":"index_label-text__L-42H","value":"index_value__U1L9R"};